import { render } from "./DSCList.vue?vue&type=template&id=1cfdcee8"
import script from "./DSCList.vue?vue&type=script&lang=js"
export * from "./DSCList.vue?vue&type=script&lang=js"
script.render = render

export default script